import React, { useState } from "react";
// import { signInWithPopup } from "firebase/auth";
// import { auth, googleProvider } from "./firebaseConfig";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Link } from 'react-router-dom';
import './FormStyles.css';

export default function Signin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState(""); // State to hold messages

    //   const handleGoogleSignIn = async () => {
    //     try {
    //       await signInWithPopup(auth, googleProvider);
    //     } catch (error) {
    //       console.error(error);
    //     }
    //   };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const auth = getAuth();
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            if (!user.emailVerified) {
                setMessage("Please verify your email before proceeding.");
            } else {
                // Redirect or other logic
            }
        } catch (error) {
            if (error.code === "auth/invalid-login-credentials") {
                setMessage("Invalid email or password.");
            } else {
                setMessage(error.message); // For other error types
            }
            console.error(error);
        }
    };



    return (
        <form className="form-container" onSubmit={handleSubmit}>
            <input className="form-input" type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
            <input className="form-input" type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
            <button className="form-button" type="submit">Sign In</button>
            <p>Don't have an account? <Link to="/signup">Sign Up</Link></p>
            {message && <div className="form-message">{message}</div>}
        </form>
    );
}
